// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-reviews--product .without_reviews p{margin-bottom:1em}.lad-reviews--product .list-unstyled li{padding:0}.lad-reviews--product .list-unstyled li i{position:inherit;left:inherit;top:inherit}.lad-reviews--product .list-unstyled li+li{margin-top:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
